import React from 'react'
import { useEffect, useState } from "react"
import './home.css'

import img1 from './carsoul/11.png'
import img2 from './carsoul/12.png'
import img3 from './carsoul/13.png'
import img4 from './carsoul/14.png'
import img5 from './carsoul/15.png'
import img6 from './carsoul/16.png'
import img7 from './carsoul/17.png'
import img8 from './carsoul/18.png'
import img9 from './carsoul/19.png'
import img10 from './carsoul/20.png'


const Home = () => {

  const [selectedImage, setSelectedImage] = useState(0)
  const [allImages, setAllImages] = useState([img1, img2, img3, img4, img5, img6, img7, img8, img9, img10])

  useEffect(() => {
    setInterval(() => {
      setSelectedImage([Math.floor(Math.random() * 10)])
    }, 3000)
  }, [])

  return (
    <>

    <div className='first'>
      <h2>CSBOOKSPDF</h2>
      <h4>A heaven of computer science books</h4>
    </div>

    <div className='carsoul'>
    <img className='carsoul-img' src={allImages[selectedImage]} />
    </div>

    <div className='second'>
    <p>Welcome to our computer science books website! Here you will find a vast collection of books that cover 
      a wide range of computer science topics, including programming, algorithms, data structures,
       artificial intelligence, cybersecurity, and more. Whether you are a beginner or an advanced
        learner, we have something for you.</p>
    </div>
    


    
  {/* <section className="hero">
    <h2>Discover the Beauty of...</h2>
    <h3>Travel</h3>
    <button>Learn More</button>
  </section>
  <section className="features">
    <h2>Our Features</h2>
    <ul>
      <li>Beautifully designed</li>
      <li>Easy to use</li>
      <li>Fast loading pages</li>
      <li>Responsive</li>
    </ul>
  </section>
  <section className="testimonial">
    <h2>What Our Customers Say</h2>
    <p>
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam auctor est
      sit amet sapien pulvinar, at venenatis enim mattis. Pellentesque habitant
      morbi tristique senectus et netus et malesuada fames ac turpis egestas.
      Curabitur vel leo vestibulum, luctus ipsum eu, aliquam nisi. Curabitur
      iaculis libero sit amet ipsum molestie tincidunt."
    </p>
    <cite>Jane Doe</cite>
  </section> */}

    
    </>

  )
}

export default Home